import googleAnalytics from './googleAnalytics';
import mixpanel from './mixpanel';
import amplitude from './amplitude';
import datahub from './datahub';
import logger from './logger';

export default [googleAnalytics, mixpanel, amplitude, datahub, logger];
